import React from "react";
//import { michelinLogoVerical } from "../../assets/index";
import "./FooterStyle.scss";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* <img
          src={michelinLogoVerical}
          alt="Company Logo"
          className="footer-logo"
        /> */}
        <div className="separator"></div>
        <p>Copyright © 2024 MICHELIN MyTechXpert. All rights reserved.</p>
        <div className="footer-links">
          <a href="https://tep-prod.michelin.com/dealers-app/api/v1/storage/display-pdf?fileName=/en/General-Disclaimer-en.pdf">
            Terms of Use
          </a>
          <a href="https://tep-prod.michelin.com/dealers-app/api/v1/storage/display-pdf?fileName=/en/Cookie-Policy-en.pdf">
            Cookies
          </a>
          <a href="https://tep-prod.michelin.com/dealers-app/api/v1/storage/display-pdf?fileName=/en/Privacy-Policy-en.pdf">
            Privacy Policy
          </a>
          <a href="https://tep-prod.michelin.com/dealers-app/api/v1/storage/display-pdf?fileName=/en/Legal-Notice-en.pdf">
            Legal Notice
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
